<template>
  <div class="a-pagination slide-down-enter-active">
    <div class="a-pagination--option">
      <span class="mr-2">Show</span>
      <a-select :defaultValue="pagin.pageSize" @change="onChangePageSize">
        <template v-for="item in PAGE_OPTIONS">
          <a-select-option :key="item" :value="item">{{ item }}</a-select-option>
        </template>
      </a-select>
      <span class="ml-2">Total {{ pagin.total }} records found.</span>
    </div>
    <a-pagination v-model="pagin.current" :total="pagin.total" :pageSize="pagin.pageSize" @change="onChangePage">
      <template slot="buildOptionText" slot-scope="props">
        <span>{{ props.value }}</span>
      </template>
    </a-pagination>
  </div>
</template>

<script>
  import { transformSearchParamsToObject } from '@shared/helpers/utils';
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  export default {
    name: 'PaginationBar',
    props: {
      current: {
        type: Number,
        default: 1
      },
      pageSize: {
        type: Number,
        default: 5
      },
      total: {
        type: Number,
        default: 0
      },
      storageKey: {
        type: String,
        default: 'pageSize'
      }
    },
    watch: {
      total: {
        immediate: false,
        handler(count) {
          this.pagin.total = count;
        }
      },
      current(val) {
        if (typeof val === 'number' && val > 0 && val !== this.pagin.current) {
          this.pagin.current = val;
        }
      },
      pageSize(val) {
        if (typeof val === 'number' && val > 0 && val !== this.pagin.pageSize) {
          this.pagin.pageSize = val;
        }
      }
    },
    data() {
      let pageSize = Number(window.localStorage.getItem(this.storageKey));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        }
      };
    },
    mounted() {
      this.pagin.current = this.current;
      this.pagin.pageSize = this.pageSize;
      this.pagin.total = this.total;
    },
    methods: {
      onChangePageSize(pageSize) {
        this.pagin.pageSize = Number(pageSize);
        this.pagin.current = 1;
        window.localStorage.setItem(this.storageKey, this.pagin.pageSize);
        this.$emit('change', this.pagin);
      },
      onChangePage(current) {
        this.pagin.current = Number(current);
        this.$emit('change', this.pagin);
      },
      updateUrl() {
        try {
          const searchParams = new URLSearchParams({ ...transformSearchParamsToObject(), ...this.pagin });
          history.pushState({}, null, this.$route.path + '?' + decodeURIComponent(searchParams.toString()));
        } catch (error) {
        }
      }
    }
  };
</script>

<style></style>
